// Mirrors PassVaultapi's utilities/otpConstants.js -- kept in sync by hand,
// same as every other enum this frontend duplicates from the API.
export const OTPType = {
  GOOGLE_AUTHENTICATOR: 1,
  MAIL: 2,
};
